import React from "react";
import { MapPin, Sparkles } from "lucide-react";
import { profile } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function About() {
  return (
    <section id="profil" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
        {/* image */}
        <Reveal className="relative order-2 md:order-1">
          <div className="relative max-w-md mx-auto">
            <div className="absolute -inset-3 border border-[#B79A80] rounded-3xl rotate-[-3deg]" />
            <div className="rounded-3xl shadow-[0_30px_70px_-25px_rgba(58,48,42,0.45)] relative h-[520px] bg-gradient-to-br from-[#F3E9DD] to-[#E7D8C6] overflow-hidden flex flex-col items-center justify-center text-center px-10">
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#C88A63]/15" />
              <div className="absolute -bottom-12 -left-8 w-44 h-44 rounded-full bg-[#B0603F]/10" />
              <Sparkles size={34} className="text-[#B0603F] mb-4" strokeWidth={1.4} />
              <span className="font-body text-[10px] tracking-luxe uppercase text-[#8F4A2E]">
                {profile.brand}
              </span>
              <span className="font-script text-6xl text-[#B0603F] mt-1 leading-none">
                {profile.name}
              </span>
              <span className="font-body text-xs tracking-wide-2 uppercase text-[#6B5D53] mt-3">
                {profile.role}
              </span>
              <span className="h-px w-14 bg-[#B79A80] my-5" />
              <p className="font-serif-display italic text-2xl text-[#3A302A] leading-snug max-w-xs">
                {profile.tagline}
              </p>
            </div>
            <div className="absolute -bottom-6 -right-4 bg-[#B0603F] text-[#FAF5EF] rounded-2xl px-6 py-4 shadow-lg">
              <div className="font-serif-display text-3xl">3+ ans</div>
              <div className="font-body text-[10px] tracking-wide-2 uppercase opacity-85">d'expérience</div>
            </div>
          </div>
        </Reveal>

        {/* text */}
        <Reveal className="order-1 md:order-2">
          <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">Profil & Contact</span>
          <h2 className="font-serif-display text-5xl md:text-6xl font-light text-[#3A302A] mt-3">
            Hii <span className="font-script text-[#B0603F]">!</span>
          </h2>

          <div className="flex items-center gap-2 mt-4 text-[#6B5D53]">
            <MapPin size={16} className="text-[#B0603F]" />
            <span className="font-body text-sm tracking-wide-2 uppercase">{profile.location}</span>
          </div>

          <div className="mt-6 space-y-4">
            {profile.bio.map((p, i) => (
              <p key={i} className="font-body text-[#6B5D53] leading-relaxed text-lg">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-8 inline-flex items-center gap-3 bg-[#F3E9DD] rounded-full pl-5 pr-6 py-3">
            <Sparkles size={18} className="text-[#B0603F]" />
            <span className="font-serif-display italic text-xl text-[#3A302A]">
              {profile.tagline}
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
